import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { DrawerLink } from '@/components/global/drawers/DrawerLink.jsx';
import { ImageField, useTranslate } from 'react-admin';
import NoImageIcon from '@/assets/icons/no-image-icon.svg?react';
import { globalStyles } from '@/themes/commonStyles/index.js';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';

const Element = ({ item, total }) => {
    const percentage = total > 0 ? (item.current / total) * 100 : 0;

    return (
        <Box className='product-ranking-element' sx={globalStyles.productRankingElement}>
            <DrawerLink
                resource='product'
                className='product-ranking-link'
                source={item.id}
                action='show'
                relative
                label={
                    <>
                        {item.pictureUrl ? (
                            <ImageField className='product-ranking-image' source='pictureUrl' record={item} />
                        ) : (
                            <Box className='product-ranking-image no-image-icon'>
                                <NoImageIcon />
                            </Box>
                        )}
                        <Typography className='product-ranking-name'>
                            {item.name}
                            <Typography className='ean-number' component='span'>
                                {item.ean}
                            </Typography>
                        </Typography>
                        <Typography className='product-ranking-percentage' component='span'>
                            {percentage.toFixed(2)}%
                        </Typography>
                    </>
                }
            />
        </Box>
    );
};

const DeviceDetailsTopProducts = ({ data, isLoading, error, total }) => {
    const translate = useTranslate();
    const products = (data?.products || []).filter(product => product.current > 0);

    return (
        <Box className='padding-wrapper device-details-stats'>
            <Typography variant='h5' sx={{ marginBottom: '24px' }}>
                {translate('resources.device.labels.topProducts')}
            </Typography>
            {isLoading ? (
                <CircularProgress />
            ) : error ? (
                <NotificationBox variant='error' className='large'>
                    {translate('resources.device.labels.loadingError')}
                </NotificationBox>
            ) : (
                products.map(item => <Element key={item.id} item={item} total={total} />)
            )}
            {!isLoading && products.length < 5 && (
                <NotificationBox variant='info' className='large'>
                    {translate('resources.device.labels.noDataError')}
                </NotificationBox>
            )}
        </Box>
    );
};

export default DeviceDetailsTopProducts;
